
import { Container } from "react-bootstrap";
import CameraGrid from "../../components/liveCamera/CameraGrid";
import LiveFilters from "../../components/liveCamera/ LiveFilters";
import { useEffect, useState } from "react";
import { getActiveBookingsParkingLocation, getCameras, getCameraLiveStreaming } from "../../services/Networkcall";
import { errorAlert } from "../../components/common/Alert";
import { Loader } from "../../components/common/Loader";
import { ReactSelect } from "../../components/common/ReactSelect";

export default function LiveCameraPage({ view, setView }) {
    const [loading, setLoading] = useState(false);
    const [parkingLocations, setParkingLocations] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState("");
    const [cameras, setCameras] = useState([]);
    const [activeCameras, setActiveCameras] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [camerasPerPage, setCamerasPerPage] = useState(6);

    // ================================
    // RESPONSIVE CAMERAS PER PAGE
    // ================================
    useEffect(() => {
        const updateCamerasPerPage = () => {
            setCamerasPerPage(window.innerWidth <= 768 ? 3 : 6);
        };
        updateCamerasPerPage();
        window.addEventListener("resize", updateCamerasPerPage);
        return () => window.removeEventListener("resize", updateCamerasPerPage);
    }, []);

    // ================================
    // FETCH LOCATIONS
    // ================================
    const fetchLocationOptions = async () => {
        setLoading(true);
        try {
            const res = await getActiveBookingsParkingLocation();
            if (res.success) {
                const options = res.data.map((e) => ({
                    label: e?.locationName,
                    value: e?._id,
                }));
                setParkingLocations(options);
                if (res.data[0]?._id) {
                    setSelectedLocation(res.data[0]._id);
                }
            } else {
                errorAlert({ message: res.message || "Failed to load locations." });
            }
        } catch (err) {
            errorAlert({ message: err?.response?.data?.message || err?.message || "Failed to load locations." });
        } finally {
            setLoading(false);
        }
    };

    // ================================
    // FETCH CAMERAS
    // ================================
    const fetchCameras = async () => {
        if (!selectedLocation) return;
        setLoading(true);
        try {
            const res = await getCameras(selectedLocation);
            if (res.success) {
                setCameras(res.data);
            } else {
                errorAlert({ message: res.message || "Failed to load cameras." });
            }
        } catch (err) {
            errorAlert({ message: err?.response?.data?.message || err?.message || "Failed to load cameras." });
        } finally {
            setLoading(false);
        }
    };

    // ================================
    // FETCH LIVE STREAMS — runs when cameras list changes
    // ================================
    useEffect(() => {
        setActiveCameras([]);

        async function updateStreams() {
            const res = await getCameraLiveStreaming(cameras);
            setActiveCameras(res?.data || []);
            setCurrentPage(1);
        }

        if (cameras.length !== 0) {
            updateStreams();
        }
    }, [cameras]);

    // ================================
    // EFFECTS
    // ================================
    useEffect(() => {
        fetchLocationOptions();
    }, []);

    useEffect(() => {
        fetchCameras();
    }, [selectedLocation]);

    return (
        <>
            <Loader show={loading} />
            <Container fluid className="lc-page vh-100 overflow-scroll">
                <div className="lc-header pt-2 mb-2">
                    <div>
                        <h3>Live Cameras</h3>
                        <p>Monitor your yards and gates in real time.</p>
                    </div>

                    <div className="lc-actions">
                        <ReactSelect
                            label="Select Yard"
                            options={parkingLocations}
                            value={parkingLocations.find((o) => o.value === selectedLocation) || null}
                            onChange={(option) => setSelectedLocation(option?.value || "")}
                        />
                    </div>
                </div>

                {/* <LiveFilters cameras={cameras} /> */}
                {/* <hr/> */}

                <CameraGrid
                    view={view}
                    cameras={cameras}
                    activeCameras={activeCameras}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    camerasPerPage={camerasPerPage}
                />
            </Container>
        </>
    );
}